<div class="px-5 sm:px-10">
  <div class="back-link" *ngIf="showBackLink || breadCrumb">
    <ng-container *ngTemplateOutlet="breadCrumb"></ng-container>
    <span
      *ngIf="showBackLink && !breadCrumb"
      (click)="back()"
      class="menu-item cursor-pointer"
      >&#8592; {{ backLinkText }}</span
    >
  </div>
  <ng-content select="[heading]" class=""></ng-content>

  <div class="flex items-center flex-wrap">
    <div
      class="flex my-10 items-center flex-none"
      [ngClass]="{ 'basis-1/4': hasFilterBar }"
      *ngIf="title"
    >
      <span class="page-icon"><ng-content select="[icon]"></ng-content> </span>
      <span class="page-heading">
        {{ title }}
      </span>
      <span class="status-box" *ngIf="status">
        {{ status }}
      </span>
    </div>
    <div [ngClass]="hasFilterBar || hasButtons ? 'flex-1 basis-3/4' : 'flex-1'">
      <div class="flex flex-row space-x-1 justify-end mb-2">
        <ng-content select="[filter-bar]" class=""></ng-content>
        <ng-content select="[buttons]" class=""></ng-content>
      </div>
    </div>
  </div>

  <div class="w-full">
    <div *ngIf="showContent">
      <ng-content></ng-content>
    </div>
  </div>
</div>
